import CityPageTemplate from "../city-template/CityPageTemplate";
import { fredericksburgVaConfig } from "./data";

export default function FredericksburgVaPage() {
  return <CityPageTemplate config={fredericksburgVaConfig} />;
}